<!-- <app-cytologicalreport *ngIf="isOldReport"></app-cytologicalreport> -->
<app-cytologicalreportv2 *ngIf="!servicePoint.citologyVersion || servicePoint.citologyVersion === 'v4'"></app-cytologicalreportv2>
<app-cytologicalreportv3 *ngIf="servicePoint.citologyVersion === 'v3'"></app-cytologicalreportv3>


